import MarkerType from './MarkerType';

/* eslint-disable import/prefer-default-export */
export const mapId = 'vellohealth_map';

export const NETWORK_TAB_SLUGS = {
  ALL_CLIENTS: 'all-clients',
  MANAGE_ALLOCATION: 'manage-allocation',
  ALLOCATED_CLIENTS: 'allocated-clients',
  TEAM_MEMBERS: 'team-members',
  CRISIS_MAP: 'crisis-map',
  MANAGE_CRISIS_ALLOCATION: 'manage-crisis-allocation',
} as const;

export const LOAD_MODE_END_INDEX = 5;
export const CRISIS_ITEM_KEY_PREFIX = 'crisis-item-';
export const CRISIS_ITEM_ACTIVE_CLASS = 'crisisHighlight';
export const CRISIS_ITEM_ACTIVE_CLASS_DELAY = 3000;

export const CRISIS_TEAM_MEMBER_TYPES = new Set([
  MarkerType.CRISIS_TEAM_MEMBER,
  MarkerType.CRISIS_TEAM_MEMBER_ALLOCATED,
  MarkerType.CRISIS_TEAM_MEMBER_VISIT_STARTED,
]);

export const CRISIS_CALL_TYPE = {
  DISPATCHED: 'dispatched',
  REGULAR: 'regular',
} as const;
